import { Component, Input, OnInit } from '@angular/core';
import { TotemWidget } from '../totem-widget';

@Component({
    selector: 'app-totem-widget-identity',
    templateUrl: './totem-widget-identity.component.html',
    styleUrls: ['./totem-widget-identity.component.scss'],
    standalone: false
})
export class TotemWidgetIdentityComponent extends TotemWidget implements OnInit {

    size:'md' = 'md'
    
    @Input() image:string
    @Input() name:string
    /** e.g. client / agency name shown after "provided by" */
    @Input() providedBy:string
    @Input() email:string
    @Input() phone:string

    /** @deprecated kept for backward compatibility with mock contact */
    @Input() contact:string
    @Input() abstract:string
    @Input() description:string

    get emailHref() {
        const value = this.email || (this.contact?.includes('@') ? this.contact : null);
        return value ? ('mailto:' + value) : null;
    }

    get phoneHref() {
        const value = this.phone || (this.contact && !this.contact.includes('@') ? this.contact : null);
        return value ? ('tel:' + value) : null;
    }

    get hasContacts() {
        return !!(this.emailHref || this.phoneHref);
    }
}
